<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/frameworks']" appearance="plain" variant="neutral">&larr; Back to UI Frameworks</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Angular Material</h1>
					<p waBody="m" waText>Angular Material 19.1.4 &mdash; Google's official Material Design component library for Angular with 30+ type-safe Java wrappers. Accordion, autocomplete, buttons, checkboxes, chips, dialogs, form fields, icons, progress bars, selects, and tables with CRTP fluent APIs, Roboto font injection, Material Icons, and prebuilt Azure Blue theme.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Angular Material 19.1.4</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:angular-material</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.core.angular.angular</p>
					<p waBody="s" waText>Built on: Angular Material 19.1.4</p>
				</div>
				<wa-details open summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_35" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_36" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details open summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_37" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Features (14)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>30+ Material Design components &mdash; Accordion, Autocomplete, Button, Checkbox, Chips, Dialog, Form Field, Icon, Progress Bar, Select, Table</p>
						<p waBody="s" waColorText="quiet" waText>Prebuilt themes &mdash; Azure Blue theme auto-loaded via &#64;NgStyleSheet</p>
						<p waBody="s" waColorText="quiet" waText>Material Icons &mdash; Google Material Icons font auto-injected</p>
						<p waBody="s" waColorText="quiet" waText>Roboto font &mdash; auto-injected via page configurator</p>
						<p waBody="s" waColorText="quiet" waText>Accordion &mdash; expansion panels with display modes, toggle positions, and action rows</p>
						<p waBody="s" waColorText="quiet" waText>Form fields &mdash; mat-form-field wrappers with label, hint, error, prefix/suffix support</p>
						<p waBody="s" waColorText="quiet" waText>Autocomplete &mdash; type-ahead suggestions with filtering</p>
						<p waBody="s" waColorText="quiet" waText>Chips &mdash; input chips with autocomplete and grid layout</p>
						<p waBody="s" waColorText="quiet" waText>Dialog &mdash; modal dialogs with typed data passing</p>
						<p waBody="s" waColorText="quiet" waText>Table &mdash; mat-table with sorting, pagination, and data sources</p>
						<p waBody="s" waColorText="quiet" waText>Select &mdash; single and multi-select dropdowns</p>
						<p waBody="s" waColorText="quiet" waText>Progress bars &mdash; determinate, indeterminate, buffer, and query modes with color variants</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for component configuration</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_38" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://material.angular.io/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://material.angular.io/components/categories</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AngularMaterial</wa-tag>
				</div>
			</div>
		</wa-card>
		<div class="wa-stack wa-gap-m">
			<h2 waHeading="l" waText>Components &#40;12&#41;</h2>
			<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
			<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatAccordion</h4>
						<p waBody="s" waColorText="quiet" waText>Material Design expansion panel accordion with multi-expand and display modes</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">2 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-accordion']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatAutoComplete</h4>
						<p waBody="s" waColorText="quiet" waText>Autocomplete input with filtered suggestions and option groups</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">3 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-auto-complete']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatButton</h4>
						<p waBody="s" waColorText="quiet" waText>Material Design raised, flat, stroked, fab, and icon buttons</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
							<wa-tag pill variant="neutral">7 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatCheckbox</h4>
						<p waBody="s" waColorText="quiet" waText>Material Design checkbox with indeterminate state and label positioning</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-checkbox']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatChipAutoComplete</h4>
						<p waBody="s" waColorText="quiet" waText>Chip input with autocomplete suggestions and removable chips</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">2 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-chip-auto-complete']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatDialog</h4>
						<p waBody="s" waColorText="quiet" waText>Modal dialog with open/close lifecycle, data injection, and configurable dimensions</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="warning">3 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-dialog']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatFormField</h4>
						<p waBody="s" waColorText="quiet" waText>Form field wrapper with label, hint, prefix/suffix, and error messages</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">6 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-form-field']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatIcon</h4>
						<p waBody="s" waColorText="quiet" waText>Material Design icon component with ligature, SVG, and font icon support</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-icon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatProgressBar</h4>
						<p waBody="s" waColorText="quiet" waText>Linear progress indicator with determinate, indeterminate, buffer, and query modes</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-progress-bar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatSelect</h4>
						<p waBody="s" waColorText="quiet" waText>Dropdown select with option groups, multiple selection, and search</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="warning">2 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-select']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatTable</h4>
						<p waBody="s" waColorText="quiet" waText>Data table with sorting, pagination, column definitions, and data source binding</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-table']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>MatTablePaginator</h4>
						<p waBody="s" waColorText="quiet" waText>Paginator control for MatTable with page size options and navigation</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/angular-material/mat-table-paginator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>